export class DayMonth  {
    label: string;
    selected: string;
    constructor (label,selected) {
        this.label = label;
        this.selected = selected;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/rtb/info/class/day-month.ts